import React, {useEffect, useRef, useState} from 'react';
import emailjs from '@emailjs/browser';
import Text from './components/UI/Text';
import Link from './components/UI/Link';
import Input from './components/UI/Input';
import Button from './components/UI/Button'
import Textarea from './components/UI/Textarea';
import Image from './components/UI/Image';
import Icon from './components/UI/Icon';
import Modal from './components/UI/Modal';
import './App.scss';
import LoadingSpinner from './components/UI/LoadingSpinner';

const App = () => {
  const buttonBooking = useRef(null);
  const buttonNewsletter = useRef(null);
  const buttonCalendar = useRef(null);
  const inputFirstname = useRef(null);
  const inputLastname = useRef(null);
  const inputNewsletter = useRef(null);
  const inputEmailBooking = useRef(null);
  const textareaBooking = useRef(null);
  const navLinkProjects = useRef(null);
  const navLinkBooking = useRef(null);
  const navLinkNewsletter = useRef(null);
  const linkTiktok = useRef(null);
  const linkInstagram = useRef(null);
  const projectsSection = useRef(null);
  const bookingSection = useRef(null);
  const newsletterSection = useRef(null);
  const form = useRef(null);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [isButtonNewsletterEnabled, setIsButtonNewsletterEnabled] = useState(false);
  const APPLE_CALENDAR_LINK = process.env.REACT_APP_APPLE_CALENDAR_LINK;
  const API_KEY_NEWSLETTER = process.env.REACT_APP_API_KEY_NEWSLETTER;
  const MAILERLITE_CREATE_SUBSCRIBER_URL = process.env.REACT_APP_MAILERLITE_CREATE_SUBSCRIBER_URL;
  const LINK_TIKTOK = process.env.REACT_APP_LINK_TIKTOK;
  const LINK_INSTAGRAM = process.env.REACT_APP_LINK_INSTAGRAM;
  const SERVICE_ID_EMIAILJS = process.env.REACT_APP_SERVICE_ID_EMEAILJS;
  const TEMPLATE_ID_EMAIL_JS = process.env.REACT_APP_TEMPLATE_ID_EMEAILJS;
  const GROUP_ID_MAILERLITE = process.env.REACT_APP_GROUP_ID_MAILERLITE;
  const PUBLIC_KEY_EMAILJS = process.env.REACT_APP_PUBLIC_KEY_EMAILJS;
  const buttonModalClose = useRef(null);
  const [isModalNewsletterOpen, setModalNewsletterOpen] = useState(false);
  const [isModalBookingOpen, setModalBookingOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);


  const openModalNewsletter = () => {
    setModalNewsletterOpen(true);
  };

  const openModalBooking = () => {
    setModalBookingOpen(true);
  };

  const closeModalNewsletter = () => {
    setModalNewsletterOpen(false);
  };

  const closeModalBooking = () => {
    setModalBookingOpen(false);
  };

  useEffect(() => {
    handleInputChangeBooking();
    handleInputChangeNewsletter();
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs.sendForm(
      SERVICE_ID_EMIAILJS,
      TEMPLATE_ID_EMAIL_JS,
      form.current,
      PUBLIC_KEY_EMAILJS
    )
      .then((result) => {
        openModalBooking();
        inputFirstname.current.value = '';
        inputLastname.current.value = '';
        inputNewsletter.current.value = '';
        textareaBooking.current.value = '';
        setLoading(false);
      }, (error) => {
        setLoading(false);
        alert('error occured');
      });
  };

  const handleInputChangeNewsletter = () => {
    const areInputsFilled = inputNewsletter.current.value.trim() !== '';

    setIsButtonNewsletterEnabled(areInputsFilled);

    if (areInputsFilled) {
      buttonNewsletter.current.classList.remove('button-inactive')
    } else {
      buttonNewsletter.current.classList.add('button-inactive')
    }
  }

  const handleInputChangeBooking = () => {

    const areInputsFilled =
      inputLastname.current.value.trim() !== '' &&
      inputFirstname.current.value.trim() !== '' &&
      inputEmailBooking.current.value.trim() !== '' &&
      textareaBooking.current.value.trim() !== '';

    setIsButtonEnabled(areInputsFilled);

    if (areInputsFilled) {
      buttonBooking.current.classList.remove('button-inactive');
    } else {
      buttonBooking.current.classList.add('button-inactive');
    }
  };

  const createSubscriberAndHandleResponse = () => {
    if (!isButtonNewsletterEnabled) return;
    setLoading(true);

    const data =
    {
      email: inputNewsletter.current.value,
      groups: [
        GROUP_ID_MAILERLITE
      ]
    }

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${API_KEY_NEWSLETTER}`
      },
      body: JSON.stringify(data)
    };

    fetch(MAILERLITE_CREATE_SUBSCRIBER_URL, options)
      .then(response => {
        if (response.ok) {
          inputNewsletter.current.value = '';
          setLoading(false);
          openModalNewsletter();
        } else {
          inputNewsletter.current.value = '';
          setLoading(false);
          alert('Failed to add subscriber try again..');
        }
      })
  };


  const handleClickButtonModalClose = (e) => {

  };

  const handleClickButtonBooking = (e) => {

  };

  const handleClickButtonNewsletter = () => {
    createSubscriberAndHandleResponse();
  };

  const handleClickButtonCalendar = (e) => {
    const url = APPLE_CALENDAR_LINK;
    window.open(url);
  };

  const handleClickInputFirstname = () => {
    handleInputChangeBooking();
  };

  const handleClickInputLastname = () => {
    handleInputChangeBooking();
  };

  const handleClickInputNewsletter = () => {
    handleInputChangeNewsletter();
  };

  const handleClickInputEmailBooking = () => {
    handleInputChangeBooking();
  };

  const handleClickTextareaBooking = () => {
    handleInputChangeBooking();
  };

  const handleClickNavLinkProjects = () => {
    projectsSection.current.scrollIntoView({behavior: 'smooth'});
  };

  const handleClickNavLinkBooking = () => {
    bookingSection.current.scrollIntoView({behavior: 'smooth'});

  };

  const handleClickNavLinkNewsletter = () => {
    newsletterSection.current.scrollIntoView({behavior: 'smooth'});

  };

  const handleClickLinkTiktok = () => {
    const url = LINK_TIKTOK
    window.open(url);
  };

  const handleClickLinkInstagram = () => {
    const url = LINK_INSTAGRAM;
    window.open(url);
  };

  return (
    <div className="App container-lg">
      <main className='hero'>
        <div className='hero__content-wrapper'>
          <div className='hero__content'>
            <nav className='flex-row nav'>
              <Link className="nav__link link-projects" content={"Projects"} ref={navLinkProjects} onClick={handleClickNavLinkProjects}></Link>
              <Link className="nav__link link-booking" content={"Booking"} ref={navLinkBooking} onClick={handleClickNavLinkBooking}></Link>
              <Link className="nav__link link-newsletter" content={"Newsletter"} ref={navLinkNewsletter} onClick={handleClickNavLinkNewsletter}></Link>
            </nav>
            <Text className="hero__hashtag" content={"#Dancers"}></Text>
            <span className='hero__title'>
              <Text className="hero__title-start" content={"god"}></Text>
              <Text className="hero__title-end" content={"twins"}></Text>
            </span>
            <Text className="hero__description" content={
              "We are dancers form Germany doing street dance #youknowthevibes"
            } />
            <div className='hero__insights flex-row'>
              <div className='hero__insight insight flex-column'>
                <Text className='hero__insight--number' content={"200"}></Text>
                <Link
                  className="hero__insight--link social-media-link link-titkok"
                  content={"TikTok"}
                  ref={linkTiktok}
                  onClick={handleClickLinkTiktok}
                ></Link>
              </div>
              <div className='hero__insight insight flex-column'>
                <Text className='hero__insight--number' content={"6.5"}></Text>
                <Link
                  className="hero__insight--link social-media-link link-instagram"
                  content={"Instagram"}
                  ref={linkInstagram}
                  onClick={handleClickLinkInstagram}
                ></Link>
              </div>
            </div>
            <div>
            </div>
          </div>
          <Image className="hero__image" />
        </div>
      </main>
      <section className='projects' ref={projectsSection}>
        <Text className="projects__title" content={'Brands we have worked with'} />
        <div className='projects__list flex-row'>
        </div>
      </section>
      <section className='project-content'>
        <Text className="projects__name" content={'Fanta'} />
        <div className='projects__description flex-row'>
          <Text className="projects-content__description" content={'Fanta Advertisment with @julianbam 2017'} />
          <Icon className={'icon-link'}>
            <Link className="projects-content__link" href={'https://www.youtube.com/watch?v=fQOpKLn9Pcg&ab_channel=FantaDeutschland'}></Link>
          </Icon>
        </div>
        <div className='project-content__item'>
          <Image className="fanta-image-1" />
        </div>
        <Text className="projects__name" content={'RTL'} />
        <div className='projects__description flex-row'>
          <Text className="projects-content__description" content={'Promi Undercover Boss 2018'} />
          <Icon className={'icon-link'}>
            <Link className="projects-content__link" href={'https://www.focus.de/kultur/kino_tv/focus-fernsehclub/tv-kolumne-promi-undercover-boss-mieses-kostuem-bart-und-haare-sollen-detlef-d-soost-tarnen-er-fliegt-sofort-auf_id_8564473.html9'}></Link>
          </Icon>
        </div>
        <div className='project-content__item'>
          <Image className="rtl-image-1" />
        </div>
        <Text className="projects__name" content={'VOX'} />
        <div className='projects__description flex-row'>
          <Text className="projects-content__description" content={'VOX die SUPEERZWILLINGE 2021'} />
          <Icon className={'icon-link'}>
            <Link className="projects-content__link" href={'https://www.vox.de/cms/die-superzwillinge-mit-amira-pocher-hier-gewinnt-man-nur-im-doppelpack-4859987.html?c=10da1'}></Link>
          </Icon>
        </div>
        <div className='project-content__item'>
          <Image className="vox-image-1" />
        </div>
        <Text className="projects__name" content={'Milaneo'} />
        <div className='projects__description flex-row'>
          <Text className="projects-content__description" content={'Milaneo Collaboration 2023'} />
          <Icon className={'icon-link'}>
            <Link className="projects-content__link" href={'https://www.facebook.com/reel/673299350632329'}></Link>
          </Icon>
        </div>
        <div className='project-content__item'>
          <Image className="milaneo-image-1" />
        </div>
        <Text className="projects__name" content={'Footlocker'} />
        <div className='projects__description flex-row'>
          <Text className="projects-content__description" content={'Collaboration with @Footlockereu 2023'} />
          <Icon className={'icon-link'}>
            <Link className="projects-content__link" href={'https://www.instagram.com/reel/Cs6TKQftM3D/?igshid=MTc4MmM1YmI2Ng%3D%3D'}></Link>
          </Icon>
        </div>
        <div className='project-content__item'>
          <Image className="footlocker-image-1" />
        </div>
      </section>
      <section className='booking' ref={bookingSection}>
        <Text className="booking__title" content={'Book us'} />
        <Text className="booking__description" content={'Whether it is a corporate gathering, private celebration, or any special occasion, make it unforgettable by booking our dynamic dance routines. Let us infuse your event with the magic of movement - submit your booking request today!'} />
        <form ref={form} onSubmit={sendEmail}>
          <div className='flex-row booking__name-content'>
            <Input
              className="booking__input-wrapper"
              classNameInput="booking__input"
              placeholder={'firstname'}
              ref={inputFirstname}
              name={'user_firstname'}
              onKeyDown={handleClickInputFirstname}
            />
            <Input
              className="booking__input-wrapper"
              classNameInput="booking__input"
              placeholder={'lastname'}
              ref={inputLastname}
              name={'user_lastname'}
              onKeyDown={handleClickInputLastname}
            />
          </div>
          <Input
            classNameInput="booking__input"
            placeholder={'email'}
            ref={inputEmailBooking}
            name={'user_email'}
            onKeyDown={handleClickInputEmailBooking}
          />
          <Textarea
            className="booking__textarea"
            placeholder='Describe your requests....'
            ref={textareaBooking}
            name={'message'}
            onKeyDown={handleClickTextareaBooking}
          />

          {isLoading ? <LoadingSpinner /> : <Input
            classNameInput="booking__button"
            ref={buttonBooking}
            disabled={!isButtonEnabled}
            type={'submit'}
            value={'send'}
          />}
        </form>
      </section>
      <section className='streetdance' >
        <Text className="streetdance__title" content={'StreetDance'} />
        <Text className="streetdance__description" content={'Subscribe to our Apple Calendar and never miss a groove – receive instant updates about the start dates of our upcoming dance sessions directly in your calendar'} />
        <Button
          className="streetdance__button"
          content={'Add Calendar'}
          ref={buttonCalendar}
          onClick={handleClickButtonCalendar} />
      </section>
      <section className='newsletter' ref={newsletterSection}>
        <Text className="newsletter__title" content={'Newsletter'} />
        <Text className="newsletter__description" content={"Join our vibrant dance community and stay in the groove with the latest updates on upcoming street dance sessions hosted right here in the city"} />
        <div className='flex-row newsletter__input-content'>
          <Input
            className="newsletter__input-wrapper"
            classNameInput="newsletter__input"
            placeholder={'example@godtwins.com'}
            ref={inputNewsletter}
            onKeyDown={handleClickInputNewsletter}
          />

          {isLoading ? <LoadingSpinner /> :
            <Button
              className={`newsletter__button`}
              ref={buttonNewsletter}
              onClick={handleClickButtonNewsletter}
            >
              <Icon className={'icon-save'} />
            </Button>}
        </div>
      </section>
      {isModalNewsletterOpen && (
        <Modal
          text={'subscribed successfully to newsletter ✅'}
          isOpen={isModalNewsletterOpen}
          onClose={closeModalNewsletter}
        />
      )}
      {isModalBookingOpen && (
        <Modal
          text={'Email was sended successfully 📧 🎉'}
          isOpen={isModalBookingOpen}
          onClose={closeModalBooking}
        />
      )}
    </div>
  );
}

export default App;
